import React, { useState } from "react";
import { useLocation } from "react-router-dom";
import { MinusIcon, PlusIcon } from "@heroicons/react/24/outline";

export default function DestkopNavLink({ key, label, href, isButton = false, child = null, isScolled = false, navbar = false }) {
    const [showChild, setShowChild] = useState(false);
    const location = useLocation();
    const { pathname } = location;

    const isAlternateNavbar = () => {
        if (pathname === '/contact-us') {
            return true;
        } else {
            return false;
        }
    }

    return (
        <div
            key={key}
            className={`font-notoSans font-bold text-xl relative group !text-white uppercase ${!isButton ? "hover:font-semibold transition-all duration-300" : ""}`}
            onClick={() => (child ? setShowChild(!showChild) : null)}
        >
            {isButton ? (
                <a
                    href={href}
                    className="px-6 py-3 border border-neutral-600 backdrop-blur-xl bg-white/10 rounded-md"
                >
                    {label}
                </a>
            ) : (
                <a href={href} className={`max-md:pb-1 ${child ? "flex items-end justify-end gap-x-2" : ""}`}>
                    {label}
                    {child ? showChild ? <MinusIcon width={24} className="text-brandBlue block md:hidden" /> : <PlusIcon width={24} className="text-brandBlue block md:hidden" /> : null}
                </a>
            )}

            {child ? (
                <>
                    <div
                        className={`absolute mt-4 bg-white/40 backdrop-blur-lg p-4 text-sm rounded-lg ${!showChild ? "hidden" : pathname === "/registration" ? "md:!block hidden" : "md:block hidden"
                            }`}
                    >
                        <ul className="space-y-3">
                            {child.map((value, index) => {
                                if (value.isHide) return null;

                                return (<li key={index + 2}>
                                    <a href={value.href} className="text-base 2xl:text-lg">{value.label}</a>
                                </li>)
                            })}
                        </ul>
                    </div>
                </>
            ) : null}
        </div>
    );
}
